module.exports = __webpack_public_path__ + "img/ae_start.1325bf87.png";